import { translate } from '@fiverr-private/i18n-react';
import { type CatalogTextualEntity } from '../../../../gql-operations/gql-generated';

export const translateTextualEntity = (textualEntity: CatalogTextualEntity): string => {
    if (textualEntity.translationKey) {
        return translate(textualEntity.translationKey);
    }
    return textualEntity.value;
};
